import explainFile from "./modules/explainFile";
import fileManage from "./modules/fileManage";
import filePage from "./modules/filePage";
import systemContent from "./modules/systemContent";


export default {
  explainFile,
  fileManage,
  filePage,
  systemContent,
}



// WEBPACK FOOTER //
// ./src/store/file/index.js